<template>
	<div id="app">
		<v-header></v-header>
		<router-view></router-view>
		<v-gotop></v-gotop>
		<v-footer></v-footer>
	</div>
</template>

<script>
	import Header from './components/header.vue';
	import Footer from './components/footer.vue';
	import Gotop from './components/gotop.vue';
	export default{
		name: 'App',
		data(){
			return{
			}
		},
		components:{
			'v-header': Header,
			'v-footer': Footer,
			'v-gotop':Gotop
		},
		methods: {
     }
	}
</script>

<style>
	@import url('resource/css/global.css');
</style>



// WEBPACK FOOTER //
// src/App.vue